'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Receiver = function () {
  function Receiver(global) {
    var _this = this;

    _classCallCheck(this, Receiver);

    this.window = global;
    this.messageHandlers = {};

    this.window.addEventListener('message', function (event) {
      try {
        _this.handleMessage(_this.parseMessage(event.data), event);
      } catch (e) {
        return;
      }
    });
  }

  _createClass(Receiver, [{
    key: 'parseMessage',
    value: function parseMessage(message) {
      if (typeof message === 'string') {
        try {
          message = JSON.parse(message);
        } catch (e) {
          throw new Error('Failed to parse message as JSON.');
        }
      }

      if (!this.isObject(message)) {
        throw new Error('Parsing the message should result an object.');
      }

      if (!message.hasOwnProperty('event')) {
        throw new Error('Event name missing.');
      }

      if (typeof message.event !== 'string') {
        throw new Error('Event name is not a string.');
      }

      if (!message.hasOwnProperty('source')) {
        throw new Error('Message source missing.');
      }

      if (!this.isObject(message.source)) {
        throw new Error('Message source is not an object.');
      }

      return message;
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage(message, event) {
      if (!this.messageHandlers[message.event]) {
        return;
      }

      this.messageHandlers[message.event].forEach(function (handler) {
        return handler.call(handler, message, event);
      });
    }
  }, {
    key: 'addMessageHandler',
    value: function addMessageHandler(message, callback) {
      if (!this.messageHandlers[message]) {
        this.messageHandlers[message] = [];
      }

      this.messageHandlers[message].push(callback);
    }
  }, {
    key: 'isObject',
    value: function isObject(subject) {
      var type = typeof subject === 'undefined' ? 'undefined' : _typeof(subject);
      return type === 'function' || type === 'object' && !!subject;
    }
  }]);

  return Receiver;
}();

module.exports = Receiver;


/*****************
 ** WEBPACK FOOTER
 ** /home/runner/work/emarsys-integration-js/emarsys-integration-js/~/emarsys-integration-client/dist/comm/receiver.js
 ** module id = 3
 ** module chunks = 0 1
 **/